interface ICameraButtonTurn {
  title: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
}

export const CameraTurnButton = (params: ICameraButtonTurn) => {
  return (
    //@ts-ignore
    <button
      className="slide_button_unmove"
      onClick={() => params.setSelected(params.title)}
    >
      {params.title}
    </button>
  );
};
